import React from "react";
import { Row, Col, Card, Typography, Divider, Image, Space, Button, Flex } from "antd";
import EmbeddedExperienceCard from "../ExperienceCard";
import BookingConfirm from "assets/icons/booking-confirm.svg"
import { Icon } from "ui/Icon";
import EmbeddedBookingLayout from "../EmbeddedBookingLayout";
import styles from "./BookingConfirmation.module.css"

const { Title, Text } = Typography;
const BookingConfirmation = () => {
    return (
        <EmbeddedBookingLayout type={"bookingConfirm"}>
            <Flex vertical align="center">
                <img src={BookingConfirm} alt="booking" />
                <Text className="mt-s" style={{ fontWeight: 600, marginTop: "16px" }}>
                    Your Booking Request is Pending!
                </Text>
                <Text>Your booking request has been sent to your guide. You will only be charged if the guide accepts<br /> your request. The guide will either accept or deny your request, usually within 24 hours or less.</Text>
                <Button type="primary" style={{ marginTop: "24px" }}>Browse More Experiences</Button>
            </Flex>
            <Row gutter={[24, 24]} className="mt-5xl">
                <Col lg={16} xl={18} span={24}>
                    <Card className="rounded-l" style={{ background: "#F9FBFB" }}>
                        <Row justify="space-between" align="middle">
                            <Col span={24}>
                                <Flex gap={10} wrap="wrap">
                                    <Title level={4}>
                                        Catching Redfish in Panama city
                                    </Title>
                                    <Text type="warning" className="rounded-full" style={{ background: "#FFF6E6", padding: "2px 8px" }}>
                                        Pending
                                    </Text>
                                </Flex>
                            </Col>
                        </Row>
                        <Flex gap={10} vertical className={`${styles.confirmationDetails} mt-m`}>
                            <Image
                                className={styles.confirmationImg}
                                src="https://media.istockphoto.com/id/1209712967/photo/fisherman-enjoying-his-hobby.jpg?s=612x612&w=0&k=20&c=XOONgnUDfKAXtEfUpXJr5q7p88Zrtsf1CayBazNxE1k="
                                preview={false}
                            />
                            <Row gutter={[0, 8]} className="flex-1">
                                <Col span={6}><Text>Date</Text></Col>
                                <Col span={18}><Text>08/19/25</Text></Col>
                                <Col span={6}><Text>Guests</Text></Col>
                                <Col span={18}><Text>2 adults, 1 child</Text></Col>
                                <Col span={6}><Text>Trip Length</Text></Col>
                                <Col span={18}><Text>1h</Text></Col>
                                <Col span={6}><Text>Time</Text></Col>
                                <Col span={18}><Text>4:30 PM – 5:30 PM</Text></Col>
                                <Col span={6}><Text>Address</Text></Col>
                                <Col span={18}><Text>Av. 2a Sur, Panama City Beach, FL 32408, USA</Text></Col>
                                <Col span={6}><Text>Booking ID</Text></Col>
                                <Col span={18}><Text>2485590564</Text></Col>
                            </Row>
                        </Flex>
                        <Divider />
                        <Title level={5}>Guide Information</Title>
                        <Row gutter={16} className="mt-s">
                            <Col span={8}>
                                <Space>
                                    <Icon type="feather" name="User" />
                                    <Text>Captain Alex White</Text>
                                </Space>
                            </Col>
                            <Col span={8}>
                                <Space>
                                    <Icon type="feather" name="Phone" />
                                    <Text>+1 123-456-7890</Text>
                                </Space>
                            </Col>
                            <Col span={8}>
                                <Space>
                                    <Icon type="feather" name="Mail" />
                                    <Text>guide@example.com</Text>
                                </Space>
                            </Col>
                        </Row>
                        <Divider />
                        <Title level={5} className="mb-s">Cancellation Policy</Title>
                        <Text>
                            Free cancellation before 48 hours prior to trip due to our{" "}
                            <button type="button" className={styles.linkButton}>
                                Cancellation policy
                            </button>.
                        </Text>
                    </Card>
                </Col>
                <Col lg={8} xl={6} span={24}>
                    <Flex vertical gap={24} className="">
                        <Card
                            title={<Text strong>Price Breakdown</Text>}
                            style={{ background: "#F9FBFB", borderRadius: 16 }}
                        >
                            <Row justify="space-between" className="mb-xs">
                                <Text>Solo Explorer × 3</Text>
                                <Text>$300.00</Text>
                            </Row>
                            <Row justify="space-between" className="mb-xs">
                                <Text>Taxes & Fees</Text>
                                <Text>$100.00</Text>
                            </Row>
                            <Divider style={{ margin: "8px 0" }} />
                            <Row justify="space-between">
                                <Text strong>Total:</Text>
                                <Text strong>$400.00</Text>
                            </Row>
                        </Card>
                        <Card title={<Text strong>Payment</Text>} style={{ background: "#F9FBFB", borderRadius: 16 }}>
                            <Row justify="space-between" className="mb-xs">
                                <Text strong>Paid Amount (Visa **** 1234)</Text>
                                <Text strong>$400.00</Text>
                            </Row>
                            <Text type="secondary">No charge will be made until the booking is approved.</Text>
                        </Card>
                    </Flex>
                </Col>
            </Row>
            <Flex vertical className="mt-4xl">
                <Title level={4} className="mb-xl">
                    Other Experiences Near Panama City
                </Title>
                <div className={styles.grid}>
                    {[
                        { id: 1, title: "Mountain Trek", image: "https://media.istockphoto.com/id/1209712967/photo/fisherman-enjoying-his-hobby.jpg?s=612x612&w=0&k=20&c=XOONgnUDfKAXtEfUpXJr5q7p88Zrtsf1CayBazNxE1k=" },
                        { id: 2, title: "Beach Camping", image: "https://media.istockphoto.com/id/1209712967/photo/fisherman-enjoying-his-hobby.jpg?s=612x612&w=0&k=20&c=XOONgnUDfKAXtEfUpXJr5q7p88Zrtsf1CayBazNxE1k=" },
                        { id: 3, title: "Jungle Safari", image: "https://media.istockphoto.com/id/1209712967/photo/fisherman-enjoying-his-hobby.jpg?s=612x612&w=0&k=20&c=XOONgnUDfKAXtEfUpXJr5q7p88Zrtsf1CayBazNxE1k=" }]?.map((exp, index) => (
                            <EmbeddedExperienceCard
                                key={index + 1}
                                image={exp.image}
                                title={exp.title}
                                location="Av. 2a Sur, Panama City Beach, FL 32408, USA"
                                time="02:00 PM – 04:00 PM"
                                people={3}
                                price={100}
                            />
                        ))}
                </div>
            </Flex>
        </EmbeddedBookingLayout>
    )
}

export default BookingConfirmation